import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Settings } from "lucide-react";
import { api } from "@/app/api";

const STATUS_STYLE = {
  pending_approval: "bg-amber-50 text-amber-700", active: "bg-emerald-50 text-emerald-700",
  inactive: "bg-slate-100 text-slate-500", suspended: "bg-rose-50 text-rose-700",
};
const FILTERS = [["", "All"], ["pending_approval", "Pending approval"], ["active", "Active"], ["inactive", "Inactive"], ["suspended", "Suspended"]];

export default function Affiliates() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("");

  useEffect(() => {
    const qs = status ? `?status=${status}` : "";
    api.get(`/admin/affiliates${qs}`).then((r) => setData(r.data.affiliates)).catch(() => setData([]));
  }, [status]);

  return (
    <div data-testid="admin-affiliates" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold text-ink">Affiliates</h1>
          <p className="mt-1 text-sm text-slatey">Manage affiliate applications, referral attribution, rewards and manual payouts.</p>
        </div>
        <Link to="/app/admin/affiliates/programme" data-testid="programme-settings-link"
          className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-3 text-sm font-bold text-ink hover:border-cobalt hover:text-cobalt">
          <Settings className="h-4 w-4" /> Programme settings
        </Link>
      </div>

      <div className="flex gap-2 overflow-x-auto">
        {FILTERS.map(([value, label]) => (
          <button key={value || "all"} onClick={() => setStatus(value)} data-testid={`affiliate-filter-${value || "all"}`}
            className={`min-w-max rounded-full px-4 py-2 text-xs font-bold ${status === value ? "bg-cobalt text-white" : "bg-white text-slatey border border-slate-200"}`}>{label}</button>
        ))}
      </div>

      {!data ? <p className="text-sm text-slatey">Loading…</p> : (
        <div className="overflow-x-auto rounded-3xl border border-slate-200 bg-white">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead><tr className="border-b border-slate-100 text-xs font-bold uppercase text-slatey">
              <th className="px-5 py-3">Affiliate</th><th className="px-5 py-3">Code</th><th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Referrals</th><th className="px-5 py-3">Rewards</th><th className="px-5 py-3">Joined</th>
            </tr></thead>
            <tbody>
              {data.map((affiliate, index) => (
                <tr key={affiliate.id || index} className="border-b border-slate-50 hover:bg-surface">
                  <td className="px-5 py-3">
                    <Link to={`/app/admin/affiliates/${affiliate.id}`} data-testid={`affiliate-${affiliate.id}`} className="font-bold text-cobalt hover:underline">
                      {affiliate.name}
                    </Link>
                    <p className="text-xs text-slatey">{affiliate.email} {affiliate.is_demo && <span className="ml-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-700">TEST</span>}</p>
                  </td>
                  <td className="px-5 py-3 font-mono text-xs font-bold text-ink" data-testid={`affiliate-code-${affiliate.id}`}>{affiliate.code}</td>
                  <td className="px-5 py-3"><span className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${STATUS_STYLE[affiliate.status]}`} data-testid={`affiliate-status-${affiliate.id}`}>{affiliate.status.replaceAll("_", " ")}</span></td>
                  <td className="px-5 py-3 text-slatey">{affiliate.referral_count}</td>
                  <td className="px-5 py-3 text-slatey">{affiliate.reward_count}</td>
                  <td className="px-5 py-3 text-xs text-slatey">{affiliate.created_at?.slice(0, 10)}</td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan={6} className="px-5 py-8 text-center text-sm text-slatey">No affiliates match.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
